import { render, staticRenderFns } from "./SchuleIcon.vue?vue&type=template&id=c6a83b3e"
import script from "./SchuleIcon.vue?vue&type=script&lang=js"
export * from "./SchuleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports